if (typeof window !== 'undefined') {
	require.ensure([], () => {
		((ele, eleClass, nav, navClass) => {
			let mark = true;
			let currentPosition = 56;

			function animateStickyHeader() {
				if (window.pageYOffset > currentPosition && mark === true) {
					ele.classList.add(eleClass);
					nav.forEach(navItem => navItem.classList.add(navClass));
					currentPosition = 40;
					mark = false;
				}

				if (window.pageYOffset < currentPosition && mark === false) {
					ele.classList.remove(eleClass);
					nav.forEach(navItem => navItem.classList.remove(navClass));
					mark = true;
					currentPosition = 56;
				}
			}

			window.onscroll = animateStickyHeader;
		})(document.querySelector('.header__sticky'), 'header__sticky_animate', document.querySelectorAll('.nav'), 'nav_animate');

		((ele, eleClass) => {
			const trigger = ele.querySelector('.header__menu-trigger');

			function toggleClass(el, className) {
				if (el.classList) {
					el.classList.toggle(className);
				} else {
					const classes = el.className.split(' ');
					const existingIndex = classes.indexOf(className);
		
					if (existingIndex >= 0) {
						classes.splice(existingIndex, 1);
					} else {
						classes.push(className);
					}
		
					el.className = classes.join(' ');
				}
			}

			trigger.addEventListener('click', () => {
				toggleClass(ele, eleClass);
				toggleClass(document.querySelector('body'), 'menu-active');
			});

			const event = document.createEvent('Event');
			let device;

			if (window.innerWidth < 736) {
				device = 'mobile';
			} else if (window.innerWidth <= 1024) {
				device = 'tablet';
			} else {
				device = 'desktop';
			}

			event.initEvent('device:changed', true, true);

			window.addEventListener('resize', () => {
				const width = window.innerWidth;

				if (width < 569 && device !== 'mobile') {
					device = 'mobile';
					document.dispatchEvent(event);
				}

				if (width >= 569 && width <= 1024 && device !== 'tablet') {
					device = 'tablet';
					document.dispatchEvent(event);
				}

				if (width > 1024 && device !== 'desktop') {
					device = 'desktop';
					document.dispatchEvent(event);
				}
			});

			document.addEventListener('device:changed', function(){
				ele.classList.remove(eleClass);
				document.querySelector('body').classList.remove('menu-active');
			});

		})(document.querySelector('.header'), 'header_menu-open');
	});
}



// WEBPACK FOOTER //
// ./src/components/header/header.js